export default "__VITE_ASSET__BUWdSW2a__"